@if (isFetchingDisclosure) {
  <app-spinner />
} @else if (!disclosure) {
  <div>Ingen informasjon funnet</div>
} @else {
  <details>
    <summary [attr.aria-expanded]="expandedState === 'rotated'" (click)="toggleExpandedState()">
      <span>
        <mat-icon [svgIcon]="IconNames.ice_circle_trade_in_mobile" />
        <p>
          {{ disclosure.summary }}
        </p>
      </span>
      <mat-icon
        class="rotate-animation"
        [ngClass]="{ 'rotate-animation-toggle': expandedState === 'rotated' }"
        [svgIcon]="IconNames.ice_chevron_down_narrow"
      />
    </summary>
    <div class="info-items">
      @for (infoItem of disclosure.infoItems; track infoItem) {
        <div class="info-item">
          <img
            [alt]="infoItem.image.alt"
            [src]="
              (isDarkMode | async)
                ? (infoItem.imageDarkMode?.imageUrl ?? infoItem.image?.imageUrl)
                : infoItem.image?.imageUrl
            "
          />
          <div class="sanity-overwrite" [innerHTML]="infoItem.htmlInfo"></div>
        </div>
      }
    </div>
  </details>
}
